import * as React from 'react';
import { Link } from 'react-router-dom';
import { Breadcrumb, Typography } from 'antd';
import Close from '../../assets/icons/close.png';
import { withTranslation } from 'react-i18next';
import { useTranslation } from 'react-i18next';
const { Text } = Typography;
const renderNavItem = (navigation) => {
  const items = [];
  for (const key of Object.keys(navigation)) {
    items.push(
      navigation[key] ? (
        <Breadcrumb.Item key={key}>
          <Link key={key} to={navigation[key]}>
            {key}
          </Link>
        </Breadcrumb.Item>
      ) : (
        <span key={key}>{key}</span>
      )
    );
  }
  return items;
};

const PageHeader = (props) => {
  const { title, navigation, description } = props;
  const {t} = useTranslation()
  return (
    <div className="pageHeader">
      <div>
        <p>
          {t(title)}
        </p>
        <p>
          {t(description)}
        </p>
      </div>
      {navigation && <Breadcrumb separator=".">{renderNavItem(navigation)}</Breadcrumb>}

      {props?.isClose && (
        <span className="close cursor" onClick={props.onCloseClick}>
          <img src={Close} width={20} alt={'close'} />
        </span>
      )}
    </div>
  );
};

export default PageHeader;
